import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { BOOKING_CANCEL_SCHEDULE_SUCCESS_MSG, CANCEL_BOOKING_CONFIRMATION_MODAL } from '@shared/constant/shared.constant';
import { DialogControlService } from '@shared/services/dialog-control.service';
import { ToastService } from '@shared/services/toast.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BookingTypeDetails, CancelType } from '@core/models/booking.model';
import { SuperAdminService } from '@core/services/super-admin.service';
import { PaymentSucessComponent } from '../booking-flow/payment-success/payment-success.component';
import { autoUnsubWith } from '@shared/services/utility.abstract';

@Component({
  selector: 'app-cancel-refund-modal',
  templateUrl: './cancel-refund-modal.component.html',
  styleUrls: ['./cancel-refund-modal.component.scss'],
})
export class CancelRefundModalComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  title = '';
  message = '';
  bookingId: string;
  bookingType: number;
  bookingTypeDetails = BookingTypeDetails;
  cancelType: any;
  scheduledCancelDate:string = '';
  showRadioButtonsForPendingCase: any;
  cancellationReasonDetail:string = '';
  cancellationReason:string = '';

  constructor(
    private readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly superAdminService: SuperAdminService,
    private readonly toastService: ToastService,
    private readonly dialogControlService: DialogControlService
  ) { }

  ngOnInit(): void {
    this.bookingId = this.config?.data?.bookingId;
    this.bookingType = this.config?.data?.bookingType;
    this.cancelType = this.config?.data?.cancelType;
    this.scheduledCancelDate = this.config?.data?.scheduledCancelDate || '';
    this.showRadioButtonsForPendingCase = this.config?.data?.showRadioButtonsForPendingCase;
    this.cancellationReason = this.config?.data?.cancellationReason;
    this.cancellationReasonDetail = this.config?.data?.additionalComments;
    this.initializeModalData();
  }

  private initializeModalData(): void {
    const configMap = {
      [CancelType.IsBookingRefund]: {
        title: 'Cancel current booking with refund',
        message: CANCEL_BOOKING_CONFIRMATION_MODAL.withRefund.message,
      },
      [CancelType.IsBookingWithoutRefund]: {
        title: this.showRadioButtonsForPendingCase ? 'Cancel current booking':'Cancel current booking without refund',
        message: CANCEL_BOOKING_CONFIRMATION_MODAL.withoutRefund.message,
      },
      [CancelType.IsBookingOnlySubscriptionCancel]: {
        title: CANCEL_BOOKING_CONFIRMATION_MODAL.subscriptionOnly.title,
        message: CANCEL_BOOKING_CONFIRMATION_MODAL.subscriptionOnly.message,
      },
    };

    const config = configMap[this.cancelType];
    if (config) {
      this.title = config.title;
      this.message = config.message;
    }
  }

confirm(): void {
  const request = {
    bookingId: this.bookingId,
    bookingRefund: this.cancelType,
    scheduledCancelDate:this.scheduledCancelDate,
    cancellationReasonDetail:this.cancellationReasonDetail,
    cancellationReason:this.cancellationReason
  };

  const cancelObservable =
    this.bookingType === this.bookingTypeDetails.Onetime
      ? this.superAdminService.cancelOneTimeBooking(request)
      : this.superAdminService.cancelRecurringBooking(request);

cancelObservable
  .pipe(autoUnsubWith(this.destroyRef))
  .subscribe({
    next: (response) => {
      if (this.scheduledCancelDate != '') {
        this.cancelScheduleSuccessModal();
         
      } else {
        
        this.toastService.showToastMessage('success', 'Success', response.message);
        this.superAdminService.triggerPopupClose(true);
      }
      this.ref.close();
    },
    error: (error) => {
      this.toastService.showToastMessage('error', 'Error', error?.error?.message);
    },
  });
}

  closeDialog(): void {
    this.ref.close();
  }

  cancelScheduleSuccessModal(): void {
    this.dialogControlService.openDialog(PaymentSucessComponent, {
      width: '20%',
      data: {
        bodyText: BOOKING_CANCEL_SCHEDULE_SUCCESS_MSG,
        buttonText: 'OK',
        isrefresh: true,
      },
    });
  }
}
